import React, { useCallback } from 'react';
import { TableCell } from '@mui/material';
import { TableRow, LinkClear } from './styles';
import EditIcon from '@mui/icons-material/Edit';
import { AccountRowProps } from './types';
import MergeType from '@mui/icons-material/MergeType';
import PreviewItems from './PreviewItems';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';

const AccountRow: React.FC<AccountRowProps> = ({
  row,
  mergeAccounts,
  onPressUsers,
  onPressEdit,
  onPressDonors,
  onPressGrantees,
  onPressMerge,
  onPressCustomQuestions,
}) => {
  const grantees = (row?.grantees || []).length;
  const donors = (row?.funders || []).length;
  const users = (row?.users || []).length;

  const handleCustomQuestions = useCallback(() => {
    onPressCustomQuestions(row);
  }, [row]);

  return (
    <TableRow>
      <TableCell align="left">{row.dbId}</TableCell>
      <TableCell align="left">{row.name}</TableCell>
      <TableCell align="left">{row.type}</TableCell>
      <TableCell align="left">{row?.officeLocation || '-'}</TableCell>
      <TableCell align="left" onClick={onPressGrantees}>
        {row.type === 'funder' ? (
          grantees === 0 ? (
            <span style={{ fontSize: 12 }}>No grantees as of now</span>
          ) : (
            <PreviewItems items={row?.grantees} field="name" />
          )
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell align="left" onClick={onPressDonors}>
        {row.type === 'grantee' ? (
          donors === 0 ? (
            <span>No donors as of now</span>
          ) : (
            <PreviewItems items={row?.funders} field="name" />
          )
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell align="left" onClick={onPressUsers}>
        <PreviewItems items={row?.users} field="email" />
      </TableCell>
      <TableCell align="left">
        {row.type === 'grantee' ? (
          <TrueImpactText variant="body-small">N/A</TrueImpactText>
        ) : (
          <TrueImpactText
            color="ctaPrimary"
            variant="body-small"
            onClick={handleCustomQuestions}
          >
            Add/Edit
          </TrueImpactText>
        )}
      </TableCell>
      <TableCell align="center" onClick={onPressEdit}>
        <EditIcon />
      </TableCell>
      <TableCell
        align="center"
        onClick={() => {
          onPressMerge(row);
        }}
      >
        {row.type === 'grantee' ? (
          <MergeType
            color={
              row?.dbId === mergeAccounts?.main?.dbId ||
              row?.dbId === mergeAccounts?.secondary?.dbId
                ? 'primary'
                : 'disabled'
            }
          />
        ) : (
          ''
        )}
      </TableCell>
    </TableRow>
  );
};

export default AccountRow;
